
import CardLayout from "../Layout/CardLayout";
import React from "react";
import InversionTable from "./InversionTable";

const InversionMuebles = (ciemId) => {

    const contributionForm =
        <InversionTable optionName={"inversionMueblesTable"}
                  ciemId={ciemId}
        />
    ;

    return (
        <div className="container-fluid">
            <CardLayout value={"inversionMueblesTitulo"} tablaComponent={contributionForm} />
        </div>
    );
};
export default InversionMuebles;